// extracted by mini-css-extract-plugin
export default {"container":"CookieBanner_container__jU76m"};